import { createSelector } from '@ngrx/store';
import { getStorePageState } from '../store.selectors';

export const getStoreCategoriesState = createSelector(
  getStorePageState,
  (state) => state.categoriesState
);
export const getCategoriesIsloading = createSelector(
  getStoreCategoriesState,
  (categories) => categories.isLoading
);
export const getCategoriesData = createSelector(
  getStoreCategoriesState,
  (categories) => categories.data
);
export const getCategoriesHasBeenFetched = createSelector(
  getStoreCategoriesState,
  (categories) => categories.fetched
);
export const getCategoriesError = createSelector(
  getStoreCategoriesState,
  (categories) => categories.error
);
export const getCategoriesSuccess = createSelector(
  getStoreCategoriesState,
  (categories) => categories.success
);
